// Keeps assistant image events known but invisible until rich result cards
// define a reviewed customer presentation.
import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const assistantImagePayloadSchema = z.object({ image_url: z.string() }).strip();

export const assistantImageDefinitions = {
    assistant_image: defineInvisible('assistant_image', {
        disposition: 'invisible',
        schema: assistantImagePayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
    }),
} as const;

export const assistantImageContractFixtures = {
    valid: { image_url: 'https://example.invalid/assistant-image.png' },
    malformed: { image_url: 7 },
} as const;
